import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextAreaInput } from "./simple-textarea-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "手続きの対象要件が複雑であり、「対象者」項目だけでは説明しきれない場合に限り利用します。",
  "例: サンプル市に主たる事業所の登録があり、かつ従業員の8割がサンプル市で勤務していること。加えて、前年同期比での売り上げが4割以上現象していること。",
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureDetailedRequirementInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="対象詳細要件" />
      <InputNoticeList notices={notices} />
      <SimpleTextAreaInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("procDtlRequirement")}
      />
    </div>
  );
};
